














































































































































































































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import PDFViewer from "@/components/PDFViewer.vue";
import * as M from "materialize-css";
const user = namespace("User");

@Component({
  components: {
    PDFViewer,
  },
})
export default class CvResult extends Vue {
  @Prop({ default: "" })
  readonly oid!: string;
  @Prop({ default: "" })
  readonly cvid!: string;

  @user.State
  public id!: string;

  score_dims = {
    impression: {
      essencials: [
        "FEATURE-EMAIL",
        "FEATURE-LINKEDIN",
        "FEATURE-PHONE",
        "AGE",
        "FILENAME",
        "FILE_FORMAT",
        "ATS_FRIENDLY",
      ],
      format: ["FONT-SIZE", "FONT-TYPE", "ERRORS", "DOC-LEN"],
      order: ["SECTIONS_ORDER"],
      basicSections: ["SECTIONS"],
    },
    impact: {
      cliches: ["CLICHES"],
      redundancy: ["REDUNDANCY"],
      read: ["ARI-COMPLEXITY", "READ-TIME"],
      objectives: ["OBJECTIVES"],
    },
    affinity: {
      abilities: ["ABILITIES"],
      roles: ["ROLES"],
      processes: ["PROCESSES"],
      tools: ["TOOLS"],
    },
  };

  get loading() {
    return this.cv == null;
  }

  get evaluating() {
    return this.cv == null || this.cv.evaluation == undefined;
  }

  get evaluation() {
    if (this.cv != null && this.cv.evaluation != undefined) {
      console.log("EVALUATION: '" + this.cv.evaluation + "'");
      return JSON.parse(this.cv.evaluation);
    }
    return null;
  }

  get readError() {
      const evalData = this.evaluation;
      if (evalData != null) {
        if (evalData.scores.ATS_FRIENDLY.value == 0) {
          return true;
        }
      }
      return false;
  }

  get pdfUrl() {
    return this.cv.url;
  }

  @Watch("evaluation")
  evaluationChanged(newVal: string) {
    if (newVal != null) {
      this.$nextTick(this.initFields);
    }
  }
  get scores() {
    const evaluationData = this.evaluation;
    /*
    const evaluationData = {
      features: {
        NAME: "Jessica Padilla U. Coordinadora "
      },
      experienceData: null,
      scores: {
        ERRORS: {
          id: "ERRORS",
          level: "WRONG",
          description: "Too many errors.",
          value: 0.0
        },
        "FONT-TYPE": {
          id: "FONT-TYPE",
          level: "WRONG",
          description: "Font types not accepted.",
          value: 0.0
        },
        "DOC-LEN": {
          id: "DOC-LEN",
          level: "GOOD",
          description: "",
          value: 100.0
        },
        "FONT-SIZE": {
          id: "FONT-SIZE",
          level: "OK",
          description: "Some Font size are not acceptable",
          value: 57.142857142857146
        }
      }
    };
    */
    console.log(evaluationData);
    if (evaluationData == null) {
      return {};
    }
    const evaluationScores: any = evaluationData.scores;
    const scores: any = {
      generalScore: 0,
      generalLevel: "approved",
      categories: {},
    };
    let scoresSum = 0;
    let scoresCount = 0;
    for (const [category, dims] of Object.entries(this.score_dims)) {
      const categoryScores: any = {};
      let categoryScore = 100;
      let categoryScoresSum = 0;
      let categoryValidScores = 0;
      for (const [dim, scoreKeys] of Object.entries(dims)) {
        console.log(category + " => " + dim + ":" + scoreKeys);
        let validScores = 0;
        let validScoresSum = 0;
        scoreKeys.forEach((scoreKey) => {
          if (scoreKey in evaluationScores) {
            validScores++;
            validScoresSum += evaluationScores[scoreKey].value;
          }
        });
        let dimScore = 100;
        if (validScores) {
          dimScore = validScoresSum / validScores;
        }
        const scoreLevel =
          dimScore == 100
            ? "approved"
            : dimScore > 50
            ? "comments"
            : "rejected";
        categoryScores[dim] = { score: dimScore, level: scoreLevel };
        console.log("dimScore[" + dim + "]:" + dimScore);
        categoryValidScores++;
        categoryScoresSum += dimScore;
      }
      if (categoryValidScores) {
        categoryScore = categoryScoresSum/categoryValidScores;
      }
      const categoryLevel =
        categoryScore == 100
          ? "approved"
          : categoryScore > 50
          ? "comments"
          : "rejected";
      const categoryData = {
        score: categoryScore,
        level: categoryLevel,
        dimensions: categoryScores,
      };
      scores.categories[category] = categoryData;

      console.log("categoryScore[" + category + "]:" + categoryScore);
      scoresSum += categoryScore;
      scoresCount++;
    }
    console.log("scoresSum:" + scoresSum);
    console.log("scoresCount:" + scoresCount);
    scores.generalScore = scoresSum / scoresCount;
    scores.generalLevel = Math.trunc(scores.generalScore / 20);
    return scores;
  }

  get oportunity(): any {
    return this.$store.state.selectedOportunity;
  }

  get cv(): any {
    return this.$store.state.selectedCv;
  }

  public initFields() {
    M.updateTextFields();
    const elems = document.querySelectorAll(".collapsible");
    M.Collapsible.init(elems);
  }

  mounted() {
    this.$store.dispatch("bindSelectedCv", {
      userId: this.id,
      oportunityId: this.oid,
      cvId: this.cvid,
    });
  }
}
